<template>
    <v-container id="extended-tables" fluid tag="section">
        <base-v-component heading="" link="componetns/simple-tables" />

        <base-material-card color="success" icon="mdi-clipboard-text" inline title="Registro de Pagos"
            class="px-5 py-3 mb-5">
            <v-row>
                <v-col cols="12" md="6">
                    <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones"
                        item-text="name" item-value="id" persistent-hint return-object single-line
                        v-on:change="listarEdificios()"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name"
                        item-value="id" persistent-hint return-object single-line v-on:change="listar()"></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" class="mt-10">
                    <v-data-table :headers="headers" :items="Properties" sort-by="calories" class="elevation-1"
                        :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Propiedades</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                                    hide-details></v-text-field>

                                <v-spacer></v-spacer>

                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Esta seguro de eliminar datos de su
                                            mascota?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="popUpEstadoCuenta(item)">
                                        <v-icon dense color="secondary">mdi-credit-card</v-icon>
                                    </v-btn>
                                </template>
                                <span>Estado de cuenta</span>
                            </v-tooltip>
                            <!--
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="deleteItem(item)">
                                        <v-icon dense color="primary">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar Propiedad</span>
                            </v-tooltip>
                            -->
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="openDetalle(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize"> Recargar </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </base-material-card>

        <v-snackbar v-model="snackbar" :timeout="timeout">
            {{ text }}

            <template v-slot:action="{ attrs }">
                <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-model="dialogDetails" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Detalles de cuentas</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-card-text>
                    <v-alert border="top" color="indigo" dark>
                        {{ descriptionPopUp }}
                    </v-alert>
                    <v-data-table v-model="selected" :headers="headersDetails" :items="Details" sort-by="calories"
                        class="elevation-1" :search="search" :loading="loadingTableDetails"
                        loading-text="Cargando... Por favor esperar" item-key="id" show-select>
                        <template v-slot:item.dueDate="{ item }">
                            {{ formatDate(item.dueDate) }}
                        </template>
                        <template v-slot:item.amount="{ item }">
                            {{ formatCurrency(item.amount) }}
                        </template>
                        <template v-slot:item.balance_due="{ item }">
                            <v-chip :color="getColor(item.balance_due)" class="white--text">
                                {{ formatCurrency(item.balance_due) }}
                            </v-chip>

                        </template>
                        <template v-slot:item.total_paid="{ item }">
                            {{ formatCurrency(item.total_paid) }}
                        </template>
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-radio-group v-model="row" row mandatory @change="changeRow">
                                        <v-radio label="Pendiente" value="Pendiente"></v-radio>
                                        <v-radio label="Pagado" value="Pagado"></v-radio>
                                        <v-radio label="Todos" value="Todos"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" md="6">

                                    <v-btn tile color="success" class="ma-2" @click="popUpPagos()">
                                        <v-icon left>
                                            mdi-pencil
                                        </v-icon>
                                        Ingresar Pagos
                                    </v-btn>
                                </v-col>
                            </v-row>


                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!--
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="popUpPagos(item)">
                                        <v-icon dense color="primary">mdi-cash</v-icon>
                                    </v-btn>
                                </template>
                <span>Ingresar pago</span>
                </v-tooltip>
                -->
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="verPaymentsDetalles(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>
                        </template>
                        <!-- 🔹 Fila de totales -->
                        <template v-slot:body.append>
                            <tr>
                                <td colspan="4"><strong>Total:</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumValor) }}</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumPagos) }}</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumSaldo) }}</strong></td>
                                <td></td> <!-- Espacio para acciones -->
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPagosDetails" max-width="800">
            <v-card>


                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="dialogPagosDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Detalles de pagos</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>

                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-data-table :headers="headersPaymentDetails" :items="PaymentDetails" sort-by="calories"
                        class="elevation-1" :search="search" :loading="loadingTableDetails"
                        loading-text="Cargando... Por favor esperar">
                        <template v-slot:item.amount="{ item }">
                            {{ formatCurrency(item.amount) }}
                        </template>
                        <template v-slot:item.paymentDate="{ item }">
                            {{ formatDate(item.paymentDate) }}
                        </template>
                        <!--
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="popUpPagos(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>
                        </template>
                        -->
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>


                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPagos" max-width="800">
            <v-card>
                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="dialogPagos = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Ingresar pagos</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>

                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-row>
                        <v-col cols="12" md="6"> Datos Seleccionados</v-col>
                        <v-col cols="12" md="6"> Fecha de pago</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-chip-group active-class="primary--text" column>
                                <v-chip v-for="tag in tags" :key="tag">
                                    {{ tag }}
                                </v-chip>
                            </v-chip-group>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-date-picker v-model="pickerPayment"></v-date-picker>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-autocomplete v-model="methodPayment" :items="PaymentsItems" dense filled label="Metodo"
                                clearable></v-autocomplete>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="totalAmountPayment" label="Valor Total Recibido" prefix="$"
                                type="number"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="amountPayment" label="Valor a Pagar" prefix="$"
                                type="number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="methodPayment !== 'Efectivo'">
                        <v-col cols="12" md="6"> <v-text-field v-model="documentNo" label="No Documento"
                                type="number"></v-text-field></v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="banco" :items="bancos" dense filled label="Institución financiera"
                                clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" text @click="GenerarPago()">Guardar</v-btn>
                    <v-btn color="grey" text @click="dialogPagos = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEstadoCuenta" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogEstadoCuenta = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Estado de cuenta</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" @click="exportarEstadoCuentaPDF">
                        <v-icon left>mdi-download</v-icon> Exportar PDF
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-alert border="top" color="indigo" dark>
                        {{ descriptionPopUp }}
                    </v-alert>
                    <v-row>

                        <v-col cols="12" md="5">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="startDate" label="Fecha de inicio"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate" @input="menu1 = false" :max="minimo"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="endDate" label="Fecha de fin" prepend-icon="mdi-calendar"
                                        readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" @input="menu2 = false" :max="minimo"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-btn block color="warning" @click="verDetallesEstadoCuenta()"> Refrescar </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3" sm="3" lg="3">
                            <base-material-stats-card color="info" icon="mdi-credit-card" title="Saldo Inicial"
                                :value="InitialBalance" />
                        </v-col>

                        <v-col cols="3" sm="3" lg="3">
                            <base-material-stats-card color="primary" icon="mdi-credit-card-refund" title="Cargos"
                                :value="TotalCharges" />
                        </v-col>
                        <v-col cols="3" sm="3" lg="3">
                            <base-material-stats-card color="success" icon="mdi-credit-card-refund" title="Pagos"
                                :value="TotalPayments" />
                        </v-col>

                        <v-col cols="3" sm="3" lg="3">
                            <base-material-stats-card color="orange" icon="mdi-credit-card-marker" title="Saldos"
                                :value="FinalBalance" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-data-table :headers="headersEstadoCuenta" :items="DetailsEstadoCuenta" sort-by="calories"
                                class="elevation-1" :search="search" :loading="loadingTableDetails"
                                loading-text="Cargando... Por favor esperar">
                                <template v-slot:item.transactionDate="{ item }">
                                    {{ formatDate(item.transactionDate) }}
                                </template>
                                <template v-slot:item.credit="{ item }">
                                    {{ formatCurrency(item.credit) }}
                                </template>
                                <template v-slot:item.debit="{ item }">
                                    {{ formatCurrency(item.debit) }}
                                </template>
                                <!--
                                <template v-slot:item.actions="{ item }">

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" large @click="popUpPagos(item)">
                                                <v-icon dense color="primary">mdi-cash</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ingresar pago</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" large @click="verPaymentsDetalles(item)">
                                                <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ver detalles</span>
                                    </v-tooltip>
                                </template>
                                -->
                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    name: "DashboardExtendedTables",

    data: () => ({
        descriptionPopUp: '',
        menu1: false,
        menu2: false,
        startDate: new Date(Date.now()).toISOString().substr(0, 10),
        endDate: new Date(Date.now()).toISOString().substr(0, 10),
        minimo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        dialogPagos: false,
        pickerPayment: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        amountPayment: 0,
        methodPayment: "",
        dialog: false,
        dialogDelete: false,
        headers: [
            { text: "Propietario", value: "owner" },
            { text: "Tipo", value: "propertyType" },
            { text: "Numero", value: "unitNumber" },
            { text: "Piso", value: "floor" },
            /*
            { text: "Valor $", value: "amount" },
            { text: "Pagos $", value: "total_paid" },
            { text: "Saldo $", value: "balance_due" },
             */
            { text: "Acciones", value: "actions", sortable: false },
        ],
        headersEstadoCuenta: [
            { text: "Fecha", value: "transactionDate" },
            { text: "Tipo", value: "transactionType" },
            { text: "Documento", value: "documento" },
            { text: "Description", value: "description" },
            { text: "Cargos $", value: "debit" },
            { text: "Pagos $", value: "credit" },
            //{ text: "Acciones", value: "actions", sortable: false },
        ],
        DetailsEstadoCuenta: [],
        headersEstadoCuentaTotal: [
            { text: "Valor $", value: "amount" },
            { text: "Pagos $", value: "total_paid" },
            { text: "Saldo $", value: "balance_due" },
        ],
        Properties: [],
        editedIndex: -1,
        medicamento: "",
        presentacion: "",
        literatura: "",
        search: "",
        loadingTable: false,
        snackbar: false,
        text: "",
        timeout: 6000,
        urbanizaciones: [],
        urbanizacion: [],
        edificios: [],
        edificio: [],
        dialogDetails: false,
        Details: [],
        loadingTableDetails: false,
        headersDetails: [
            { text: "Documento", value: "identity_column" },
            { text: "description", value: "description" },
            { text: "Fecha de pago", value: "dueDate" },
            { text: "status", value: "status" },
            { text: "Valor $", value: "amount" },
            { text: "Pagos $", value: "total_paid" },
            { text: "Saldo $", value: "balance_due" },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        id: "",
        row: null,
        estado: "",
        dialogPagosDetails: false,
        headersPaymentDetails: [
            { text: "Metodo", value: "paymentMethod" },
            { text: "Fecha", value: "paymentDate" },
            { text: "Valor $", value: "amount" },
            { text: "No Documento", value: "documentNo" },
            { text: "Banco", value: "bank" },
            //{ text: "Acciones", value: "actions", sortable: false },
        ],
        PaymentDetails: [],
        dialogEstadoCuenta: false,

        InitialBalance: "0",
        TotalCharges: "0",
        TotalPayments: "0",
        FinalBalance: "0",
        //pagos
        bancos: [],
        banco: '',
        PaymentsItems: ['Transferencia', 'Efectivo', 'Cheque'],
        documentNo: "",
        totalAmountPayment: 0,
        selected: [],
        tags: [],
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nueva propiedad" : "Editar propiedad";
        },
        sumPagos() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.total_paid || 0), 0));
        },
        sumSaldo() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.balance_due || 0), 0));
        },
        sumValor() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.amount || 0), 0));
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        loader() {
            const l = this.loader;
            this[l] = !this[l];

            setTimeout(() => (this[l] = false), 6000);

            this.loader = null;
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        getColor(balance_due) {
            if (balance_due > 0) return 'red lighten-3'
            else if (balance_due == 0) return 'light-green lighten-2'
            else return 'orange lighten-1'
        },
        formatDate(date) {
            if (!date) return ""; // Evita errores si la fecha es nula o indefinida
            // Maneja valores nulos o indefinidos
            const d = new Date(date);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        },
        formatNumber(value) {
            return parseFloat(value).toFixed(2);
        },
        initialize() {
            this.listarUrbanizaciones();
        },

        listarUrbanizaciones() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/Communities", configuracion)
                .then(function (response) {
                    me.urbanizaciones = response.data;
                    console.log(response.data);
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        listarEdificios() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.edificios = [];
            axios
                .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
                .then(function (response) {
                    me.edificios = response.data;
                    console.log(response.data);
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        // Formatea como moneda con "$" y 2 decimales
        formatCurrency(value) {
            if (value == null) return "$0.00";
            return `$${parseFloat(value).toFixed(2)}`;
        },
        listar() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTable = true;
            me.Properties = [];
            axios
                .get("api/Properties/PropertiesByBuilding/" + me.edificio.id, configuracion)
                .then(function (response) {
                    me.Properties = response.data;
                    //change to string bool value
                    me.loadingTable = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        guardar() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            if (this.editedIndex > -1) {
                //edit
                console.log("Actualizar " + me.unico);
                axios
                    .put(
                        "api/mascotas/Actualizar",
                        {
                            unico: me.unico,
                            nombre: me.nombre,
                            tipo: me.tipo.tipo,
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.listar();
                        console.log(response);
                    })
                    .catch((err) => {
                        if (err.response.status == 401) {
                            this.$store.dispatch("salir");
                        }
                    });
            } else {
                console.log("crear medicamento");
                axios
                    .post(
                        "api/medicamentos/Crear",
                        {
                            medicamento_descripcion: me.medicamento,
                            presentacion: me.presentacion,
                            literatura: me.literatura,
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.listar();
                        console.log(response);
                    })
                    .catch((err) => {
                        if (err.response.status == 401) {
                            this.$store.dispatch("salir");
                        }
                    });
            }
            this.close();
        },
        popUpEstadoCuenta(item) {
            let me = this;
            me.id = item.id;
            me.dialogEstadoCuenta = true;
            me.descriptionPopUp = "Propietario: " + item.owner + " Tipo:" + item.propertyType + " No:" + item.unitNumber + " Piso:" + item.floor;
            //me.verDetallesEstadoCuenta();
        },
        popUpPagos() {
            let me = this;
            if (me.selected.length === 0) {
                me.snackbar = true;
                me.text = "Debe seleccionar al menos una cuenta para generar el pago.";
                return; // Detiene la ejecución si no hay cuentas seleccionadas
            }
            me.dialogPagos = true;

            me.tags = me.selected.map(item => `No: ${item.identity_column} Valor: $${item.balance_due.toFixed(2)}`);
            me.amountPayment = me.selected.reduce((sum, item) => sum + item.balance_due, 0);
            me.listarBancos();

        },

        GenerarPago() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            if (Number(me.totalAmountPayment) < Number(me.amountPayment)) {
                me.snackbar = true;
                me.text = "El Valor Total de la Transferencia debe ser mayor o igual al Valor a Pagar.";
                return; // Detiene la ejecución si la validación falla
            }


            const payments = me.selected.map(item => ({
                account_receivable_uq: item.id,  // Toma datos de cada item en me.selected
                PaymentDate: me.pickerPayment,
                Amount: me.selected.length === 1 ? me.amountPayment : item.balance_due,
                PaymentMethod: me.methodPayment,
                TotalAmount: me.totalAmountPayment,
                Bank: me.banco,
                DocumentNo: me.documentNo
            }));
            console.log(payments);


            axios.post(
                "api/Payments/InsertPaymentsBulkJson",
                payments,
                configuracion
            )
                .then(function (response) {
                    console.log(response.data[0]["error"]);
                    if (response.data[0]["error"]) {
                        me.snackbar = true;
                        me.text = response.data[0]["messagge"];
                    } else {
                        console.log("borrar tag");
                        me.selected = [];
                        me.tags = [];
                        me.documentNo = "";
                        me.totalAmountPayment = 0;
                        me.amountPayment = 0;
                        me.methodPayment = "";
                        me.banco = "";
                        me.dialogPagos = false;
                        me.verDetalles();

                    }
                })
                .catch((err) => {
                    if (err.response && err.response.status == 401) {
                        me.$store.dispatch("salir");
                    }
                });



        },
        openDetalle(item) {
            let me = this;
            me.dialogDetails = true;
            me.id = item.id;
            me.descriptionPopUp = "Propietario: " + item.owner + " Tipo:" + item.propertyType + " No:" + item.unitNumber + " Piso:" + item.floor;
            me.verDetalles();
            console.log(item);
        },
        listarBancos() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("/api/Banks", configuracion)
                .then(function (response) {
                    //me.items = response.data;
                    me.bancos = response.data.map(item => item.name);
                    console.log("bancos ..");
                    console.log(me.bancos);
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        verDetalles() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTableDetails = true;

            axios
                .get("/api/AccountsReceivables/AccountsByProperty/" + me.id + "/" + me.estado, configuracion)
                .then(function (response) {
                    me.Details = response.data;
                    //change to string bool value
                    me.loadingTableDetails = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        verDetallesEstadoCuenta() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTableDetails = true;

            axios
                .get("/api/AccountsReceivables/Statementdetails/" + me.id + "/" + me.startDate + "/" + me.endDate, configuracion)
                .then(function (response) {
                    me.DetailsEstadoCuenta = response.data;
                    //change to string bool value
                    me.loadingTableDetails = false;
                    me.verResumenEstadoCuenta();
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        verResumenEstadoCuenta() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("/api/AccountsReceivables/StatementSummary/" + me.id + "/" + me.startDate + "/" + me.endDate, configuracion)
                .then(function (response) {
                    var resumen = response.data;
                    console.log(resumen);
                    console.log("inicial");
                    console.log(resumen[0].initialBalance);
                    me.InitialBalance = "$ " + resumen[0].initialBalance.toString();
                    me.TotalCharges = "$ " + resumen[0].totalCharges.toString();
                    me.TotalPayments = "$ " + resumen[0].totalPayments.toString();
                    me.FinalBalance = "$ " + resumen[0].finalBalance.toString();
                    //change to string bool value
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );

        },
        verPaymentsDetalles(item) {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.dialogPagosDetails = true;

            axios
                .get("api/Payments/PaymentDetails/" + item.id, configuracion)
                .then(function (response) {
                    me.PaymentDetails = response.data;
                    //change to string bool value
                    me.loadingTableDetails = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        editItem(item) {
            //this.editedIndex = this.desserts.indexOf(item);
            //this.editedItem = Object.assign({}, item);
            console.log(item);
            this.dialog = true;
        },
        changeRow(value) {
            let me = this;
            console.log("Valor seleccionado:", value);
            me.estado = value;
            me.verDetalles();
        },
        deleteItem(item) {
            //this.editedIndex = this.desserts.indexOf(item);
            //this.editedItem = Object.assign({}, item);
            console.log(item);
            this.dialogDelete = true;
        },

        deleteItemConfirm() {
            this.desserts.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        exportarEstadoCuentaPDF() {
            const doc = new jsPDF();
            let me = this;
            // Fecha y hora actual
            const now = new Date();
            const fechaGeneracion = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

            // Título
            doc.setFontSize(16);
            doc.text("Estado de Cuenta", 14, 20);
            // Línea continua horizontal (de x=14 a x=195 en la posición y=22)
            doc.setLineWidth(0.5); // grosor de la línea
            doc.line(14, 22, 195, 22);
            // Subtítulo con descripción y rango
            doc.setFontSize(10);  
            doc.text(`Urbanización: ${me.urbanizacion.name}`, 14, 28);
            doc.text(me.edificio.name, 14, 34);
            doc.text(me.descriptionPopUp, 14, 42);
            doc.text(`Desde: ${me.startDate} - Hasta: ${me.endDate}`, 14, 48);
            doc.text(`Generado el: ${fechaGeneracion}`, 14, 56);

            // Tabla
            const headers = [
                ["Fecha", "Tipo", "Documento", "Descripción", "Cargos ($)", "Pagos ($)"],
            ];

            const body = me.DetailsEstadoCuenta.map((item) => [
                me.formatDate(item.transactionDate),
                item.transactionType,
                item.documento,
                item.description,
                me.formatCurrency(item.debit),
                me.formatCurrency(item.credit),
            ]);

            doc.autoTable({
                head: headers,
                body: body,
                startY: 64, // Ajustado para que no se sobreponga
            });

            const resumenY = doc.autoTable.previous.finalY + 10;
            doc.setFontSize(12);
            doc.text(`Saldo Inicial: ${this.InitialBalance}`, 14, resumenY);
            doc.text(`Cargos: ${this.TotalCharges}`, 14, resumenY + 6);
            doc.text(`Pagos: ${this.TotalPayments}`, 14, resumenY + 12);
            doc.text(`Saldo Final: ${this.FinalBalance}`, 14, resumenY + 18);

            // Guardar el archivo
            //doc.save(`EstadoCuenta_${this.startDate}_a_${this.endDate}.pdf`);

            // Abrir en nueva ventana
            const pdfUrl = doc.output("bloburl");
            window.open(pdfUrl, "_blank");
        }

    },
};
</script>